// deps
import styled from "styled-components";

// components
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { TextButton } from "@swiggy-private/dls-web-core/dist/components/TextButton";

const TURBO_POD_ICON_DIMENSION = "72px";

export const Title = styled(Text)(({ theme }) => ({
    color: theme.colors.light.text_Highest_Emphasis,
    paddingTop: theme.spacing.xxxSmall,
    textAlign: "center",
}));

export const Subtitle = styled(Text)(({ theme }) => ({
    color: theme.colors.light.text_High_Emphasis,
    margin: `${theme.spacing.xSmall} auto ${theme.spacing.xxSmall}`,
    width: "90%",
    textAlign: "center",
}));

export const ConsentCtaSection = styled.div(({ theme }) => ({
    marginTop: theme.spacing.xxLarge,
    paddingBottom: theme.spacing.medium,
    display: "flex",
}));

export const ConsentCtaWrapper = styled.div(({ theme }) => ({
    flex: 1,
    marginRight: theme.spacing.small,
    "&:last-of-type": {
        marginRight: 0,
    },
}));

export const SubtleCtaSection = styled.div(({ theme }) => ({
    marginTop: theme.spacing.xxLarge,
    paddingBottom: theme.spacing.medium,
}));

export const SubtleSecondaryCta = styled(TextButton)(({ theme }) => ({
    marginTop: theme.spacing.medium,
}));

export const TurboPodImageWrapper = styled.div(({ theme }) => ({
    margin: `${theme.spacing.small} auto ${theme.spacing.medium}`,
    display: "flex",
    justifyContent: "center",
    border: `1.775px solid ${theme.colors.light.background_Secondary_Alpha}`,
    borderRadius: theme.spacing.medium,
    width: TURBO_POD_ICON_DIMENSION,
}));

export const TurboPodIconImage = styled(Image)`
    height: ${TURBO_POD_ICON_DIMENSION};
    width: ${TURBO_POD_ICON_DIMENSION};
    object-fit: fill;
`;
